import { render, staticRenderFns } from "./IndexContent.vue?vue&type=template&id=cd919b80"
import script from "./IndexContent.vue?vue&type=script&lang=js"
export * from "./IndexContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports